<template>
  <DefSwitch class="get-today-list-tabs">
    <button :class="{ active: activeTab === 1 }" @click="$emit('changeActiveTab', 1)">
      {{ messages.list }}
    </button>
    <button :class="{ active: activeTab === 2 }" @click="$emit('changeActiveTab', 2)">
      {{ messages.onMap }}
    </button>
  </DefSwitch>
</template>

<script setup>
import { defineProps } from 'vue';
import DefSwitch from '@components/Def/DefSwitch/DefSwitch.vue';

const { activeTab, messages } = defineProps(['activeTab', 'messages']);
</script>

<script>
export default {
  name: 'GetTodayListTabs',
};
</script>

<style lang="scss" scoped>
.get-today-list-tabs {
  width: 100%;
  @include point-md {
    width: unset;
  }
}
</style>
